const getters = {
  navActive: state => state.navActive,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js